import { createTheme } from "@mui/material/styles";
import { dark } from "@mui/material/styles/createPalette";
export const theme = createTheme({
  direction: "rtl",
  palette: {
    mode: "light",
    blue: {
      main: "#49519A",
    },
    red: {
      main: "#DF1F27",
    },
    white: {
      main: "#FCFEFF",
    },
    grey: {
      main: "#F0F0F0",
    },
  },
  typography: {
    fontFamily: "Homa",
  },
});
